import React, { useState, useEffect } from 'react';

const V0StyleLoader = ({ onComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const activities = [
    "Inicializando sistema de IA...",
    "Conectando con bases de datos de marketing...",
    "Analizando tu negocio...",
    "Identificando los diferenciales de tu marca...",
    "Escaneando tendencias y datos de mercado...",
    "Buscando anuncios de tus competidores...",
    "Identificando segmentos de audiencia ideales...",
    "Optimizando palabras clave y términos de búsqueda...",
    "Definiendo la mejor estrategia de campaña...",
    "Escribiendo los mejores textos para tu anuncio...",
    "Probando variaciones de copy y llamados a la acción...",
    "Ajustando presupuesto y objetivos de inversión...",
    "Seleccionando ubicaciones óptimas para mostrar tus anuncios...",
    "Configurando parámetros de campaña...",
    "Validando cumplimiento con políticas de las plataformas...",
    "Ejecutando chequeo de calidad...",
    "Preparando recursos y sincronizando con plataformas...",
    "Aplicando últimas optimizaciones...",
    "Finalizando configuración..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = prev + 1;
        if (next >= activities.length) {
          clearInterval(interval);
          onComplete && onComplete();
          return prev;
        }
        return next;
      });
    }, 1311); // 5% más rápido (1380 * 0.95)

    return () => clearInterval(interval);
  }, [activities.length, onComplete]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[480px] space-y-8 px-4">
      {/* Título con loader al lado */}
      <div className="flex items-center space-x-4">
        <div className="w-6 h-6 border-2 border-white/30 border-t-primary rounded-full animate-spin"></div>
        <h3 className="text-lg font-medium text-white">Estamos creando tu campaña</h3>
      </div>

      {/* Bloque con líneas de código - Glass Morphism */}
      <div className="relative w-full max-w-lg">
        {/* Difuminado superior */}
        <div className="absolute top-0 left-0 right-0 h-28 bg-gradient-to-b from-slate-900/90 via-slate-900/50 to-transparent z-10 pointer-events-none rounded-t-2xl"></div>
        
        {/* Difuminado inferior */}
        <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-slate-900/90 via-slate-900/50 to-transparent z-10 pointer-events-none rounded-b-2xl"></div>
        
        {/* Difuminado lateral izquierdo */}
        <div className="absolute top-0 bottom-0 left-0 w-16 bg-gradient-to-r from-slate-900/40 to-transparent z-10 pointer-events-none"></div>
        
        {/* Difuminado lateral derecho */}
        <div className="absolute top-0 bottom-0 right-0 w-16 bg-gradient-to-l from-slate-900/40 to-transparent z-10 pointer-events-none"></div>
        
        {/* Contenedor de líneas con Glass Morphism */}
        <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-5 h-56 overflow-hidden relative shadow-xl">
          <div 
            className="space-y-3 transition-transform duration-1000 ease-out"
            style={{ 
              transform: `translateY(-${Math.max(0, currentIndex - 2) * 40}px)`,
              fontFamily: 'Roboto Mono, monospace'
            }}
          >
            {activities.map((activity, index) => (
              <div 
                key={index}
                className={`text-base transition-all duration-500 ${
                  index === currentIndex 
                    ? 'text-blue-400 font-medium drop-shadow-[0_0_8px_rgba(96,165,250,0.5)]' 
                    : index < currentIndex 
                      ? 'text-white/60' 
                      : 'text-white/40'
                }`}
              >
                <span className={`mr-2 transition-colors duration-500 ${
                  index === currentIndex ? 'text-blue-400' : 'text-white/40'
                }`}>→</span>
                {activity}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default V0StyleLoader;
